import homeJson from './home.json'
import eventsJson from './events.json'
import merchJson from './merch.json'
import type { EventsData, HomeData, MerchData } from './types'

export const homeData = homeJson as HomeData
export const eventsData = eventsJson as EventsData
export const merchData = merchJson as MerchData
